export const SET_USER = "SET_USER";
export const SET_PROFILE = "SET_PROFILE";
export const SET_BOARD_STYLES = "SET_BOARD_STYLES";
export const SET_BOARD = "SET_BOARD";
export const CREATE_BOARD = "CREATE_BOARD";
export const SET_ACTIVE_BOARD = "SET_ACTIVE_BOARD";
export const SET_ACTIVE_CARD = "SET_ACTIVE_CARD";
export const SET_BOARD_LISTS = "SET_BOARD_LISTS";
export const SET_BOARD_CARD = "SET_BOARD_CARD";
export const ADD_CARD_TO_LIST = "ADD_CARD_TO_LIST";
export const ARCHIVE_BOARD = "ARCHIVE_BOARD";
export const DELETE_BOARD_LIST = "DELETE_BOARD_LIST";
export const HANDLE_ARCHIVE_BOARD = "HANDLE_ARCHIVE_BOARD";
export const SET_LABELS = "SET_LABELS";
export const HANDLE_SET_LABELS = "SET_LABELS";
export const SET_DESCRIPTION = "SET_DESCRIPTION";
export const SET_CARD_CHECKLIST = "SET_CARD_CHECKLIST";
export const SET_CARD_CHECKLIST_ITEM = "SET_CARD_CHECKLIST_ITEM";
export const RENAME_CHECKLIST = "RENAME_CHECKLIST";
export const RENAME_CHECKLIST_ITEM = "RENAME_CHECKLIST_ITEM";
export const DELETE_CHECKLIST = "DELETE_CHECKLIST";
export const DELETE_CHECKLIST_ITEM = "DELETE_CHECKLIST_ITEM";
export const TOGGLE_CHECKLIST_ITEM = "TOGGLE_CHECKLIST_ITEM";
export const TOGGLE_CARD_LABEL = "TOGGLE_CARD_LABEL";
export const SET_SEARCH_BOARDS = "SET_SEARCH_BOARDS";
export const EDIT_BOARD = "EDIT_BOARD";
export const SET_IS_SHOW_SHARE = "SET_IS_SHOW_SHARE";
export const SET_ATTACHMENT = "SET_ATTACHMENT";
export const SET_COMMENT = "SET_COMMENT";
export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";
export const MAKE_COVER = "MAKE_COVER";
export const CREATE_BOARD_LIST = "CREATE_BOARD_LIST";
export const RENAME_LIST = "RENAME_LIST";
export const SET_CARD_DATE = "SET_CARD_DATE";
export const SET_CARD_MEMBER = "SET_CARD_MEMBER";
export const REMOVE_CARD_DATE = "REMOVE_CARD_DATE";